// src/pages/Home.jsx
import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";


// slick styles (we already loaded them from public, but import for webpack)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/slider.css";
import FaqSection from "../components/FaqSection";

const Home = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    adaptiveHeight: true,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false
        }
      }
    ]
  };

  return (
    <div className="page">
      {/* ===== HERO SLIDER ===== */}
      <div className="banner_slider_wrapper">
        <Slider {...settings} className="banner_slider">
          {/* Slide 1 */}
          <div className="slide">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/slides/slider-mainbg-001.jpg`}
              alt="slider-mainbg-001"
              className="img-fluid"
            />
            <div className="slide-content">
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-md-8 col-sm-10 text-left" style={{ marginLeft: '0', paddingLeft: '20px' }}>
                    <div className="slide_content">
                      <h1 className="ttm-textcolor-white">
                        Professional{" "}
                        <span className="ttm-textcolor-skincolor">Translation</span>{" "}
                        Services
                      </h1>
                      <p className="text">Accuracy. Clarity. Cultural Relevance.</p>
                      <div className="slide_button">
                        <Link
                          to="/contact-us"
                          className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor"
                        >
                          Request a Quote
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="slide">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/slides/slider-mainbg-002.jpg`}
              alt="slider-mainbg-002"
              className="img-fluid"
            />
            <div className="slide-content">
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-md-8 col-sm-10 text-left" style={{ marginLeft: '0', paddingLeft: '20px' }}>
                    <div className="slide_content">
                      <h1 className="ttm-textcolor-white">
                        Language Bridging{" "}
                        <span className="ttm-textcolor-skincolor">Experts</span>
                      </h1>
                      <p className="text">Seamless Global Communication</p>
                      <div className="slide_button">
                        <Link
                          to="/contact-us"
                          className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor"
                        >
                          Request a Quote
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>

  {/* ===== site-main start ===== */}
  <div className="site-main">
          {/* introduction-section */}
          <section className="ttm-row introduction-section clearfix">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-white spacing-2 box-shadow">
                    <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
                    <div className="layer-content">
                      <div className="row align-items-center">
                        <div className="col-lg-6 col-md-7 col-sm-12">
                          <div className="section-title">
                            <div className="title-header">
                              <h5>WHY US</h5>
                              <h2 className="title">
                                Professional Language Solutions to Bridge Global Communication
                              </h2>
                            </div>
                          </div>
                          <p>
                            We are a trusted provider of translation and localization
                            services, delivering linguistic accuracy and cultural
                            relevance. Our expert linguists and native translators help
                            businesses expand across borders by overcoming language
                            barriers and enhancing global outreach.
                          </p>
                          <div className="pt-25">
                            <div className="featured-icon-box icon-align-before-content icon-ver_align-top style1">
                              <div className="featured-icon">
                                <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-style-round ttm-icon_element-color-grey ttm-icon_element-size-sm">
                                  <i className="fa fa-language" />
                                </div>
                              </div>
                              <div className="featured-content">
                                <div className="featured-title">
                                  <h5>Multilingual Translation</h5>
                                </div>
                                <div className="featured-desc">
                                  <p>
                                    Accurate document translation in over 50+ Indian
                                    regional languages by certified linguists.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="featured-icon-box icon-align-before-content icon-ver_align-top style1">
                              <div className="featured-icon">
                                <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-style-round ttm-icon_element-color-grey ttm-icon_element-size-sm">
                                  <i className="fa fa-globe" />
                                </div>
                              </div>
                              <div className="featured-content">
                                <div className="featured-title">
                                  <h5>Website & App Localization</h5>
                                </div>
                                <div className="featured-desc">
                                  <p>
                                    Enhance user experience across geographies with
                                    culturally adapted digital content.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="featured-icon-box icon-align-before-content icon-ver_align-top style1">
                              <div className="featured-icon">
                                <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-style-round ttm-icon_element-color-grey ttm-icon_element-size-sm">
                                  <i className="fa fa-headphones" />
                                </div>
                              </div>
                              <div className="featured-content">
                                <div className="featured-title">
                                  <h5>Interpretation Services</h5>
                                </div>
                                <div className="featured-desc">
                                  <p>
                                    Live interpretation support for conferences,
                                    business meetings, and multilingual events.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-5 col-sm-7 ml-auto">
                          <div className="ttm_single_image-wrapper">
                            <img
                              className="img-fluid"
                              src={`${process.env.PUBLIC_URL}/assets/images/single-img-01.png`}
                              alt="WHY US"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* service-section */}
          <section className="ttm-row service-section ttm-bgcolor-grey clearfix">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-8 m-auto">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h5>Our Exclusive Services</h5>
                      <h2 className="title">
                        The High Standard Trusted & Translation Services
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <Slider
                  className="slick_slider"
                  slidesToShow={3}
                  slidesToScroll={1}
                  arrows={false}
                  autoplay={true}
                  infinite={true}
                  responsive={[
                    {
                      breakpoint: 1100,
                      settings: {
                        slidesToShow: 3
                      }
                    },
                    {
                      breakpoint: 940,
                      settings: {
                        slidesToShow: 2
                      }
                    },
                    {
                      breakpoint: 630,
                      settings: {
                        slidesToShow: 1
                      }
                    }
                  ]}
                >
                <div className="ttm-box-col-wrapper col-lg-4">
                  <div className="featured-icon-box icon-align-before-heading style2">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                        <i className="flaticon-conversation-2" />
                      </div>
                    </div>
                    <div className="featured-title">
                      <span>Explore The Features</span>
                      <h5>Translation Services</h5>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Delivering high-quality, industry-specific translation
                          in 50+ Indian languages, ensuring accuracy, tone, and
                          cultural sensitivity across all regions.
                        </p>
                        <a
                          className="ttm-btn ttm-btn-size-md ttm-icon-btn-right ttm-btn-color-dark btn-inline"
                          href="/services"
                        >
                          Read more<i className="fa fa-plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ttm-box-col-wrapper col-lg-4">
                  <div className="featured-icon-box icon-align-before-heading style2">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                        <i className="flaticon-connection" />
                      </div>
                    </div>
                    <div className="featured-title">
                      <span>Explore The Features</span>
                      <h5>Website Localization</h5>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Localize your website content to resonate with
                          multilingual audiences, improving accessibility,
                          engagement, and customer experience globally.
                        </p>
                        <a
                          className="ttm-btn ttm-btn-size-md ttm-icon-btn-right ttm-btn-color-dark btn-inline"
                          href="/services"
                        >
                          Read more<i className="fa fa-plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ttm-box-col-wrapper col-lg-4">
                  <div className="featured-icon-box icon-align-before-heading style2">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                        <i className="flaticon-customer-service" />
                      </div>
                    </div>
                    <div className="featured-title">
                      <span>Explore The Features</span>
                      <h5>Voiceover & Subtitling</h5>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Professional voiceover and subtitling services that
                          help you reach international audiences through
                          tailored multimedia localization.
                        </p>
                        <a
                          className="ttm-btn ttm-btn-size-md ttm-icon-btn-right ttm-btn-color-dark btn-inline"
                          href="/services"
                        >
                          Read more<i className="fa fa-plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ttm-box-col-wrapper col-lg-4">
                  <div className="featured-icon-box icon-align-before-heading style2">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                        <i className="flaticon-global" />
                      </div>
                    </div>
                    <div className="featured-title">
                      <span>Explore The Features</span>
                      <h5>DTP Services</h5>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          We format multilingual documents using professional
                          Desktop Publishing tools, ensuring design consistency
                          across all target languages.
                        </p>
                        <a
                          className="ttm-btn ttm-btn-size-md ttm-icon-btn-right ttm-btn-color-dark btn-inline"
                          href="/services"
                        >
                          Read more<i className="fa fa-plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ttm-box-col-wrapper col-lg-4">
                  <div className="featured-icon-box icon-align-before-heading style2">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                        <i className="flaticon-conversation" />
                      </div>
                    </div>
                    <div className="featured-title">
                      <span>Explore The Features</span>
                      <h5>Content Writing</h5>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Custom content creation services focused on SEO,
                          marketing, and technical topics, delivered in any
                          language with brand consistency.
                        </p>
                        <a
                          className="ttm-btn ttm-btn-size-md ttm-icon-btn-right ttm-btn-color-dark btn-inline"
                          href="/services"
                        >
                          Read more<i className="fa fa-plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ttm-box-col-wrapper col-lg-4">
                  <div className="featured-icon-box icon-align-before-heading style2">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                        <i className="flaticon-connection" />
                      </div>
                    </div>
                    <div className="featured-title">
                      <span>Explore The Features</span>
                      <h5>Software Localization</h5>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          End-to-end software localization including UI/UX
                          adaptation, code string translation, and quality
                          testing to support international deployment.
                        </p>
                        <a
                          className="ttm-btn ttm-btn-size-md ttm-icon-btn-right ttm-btn-color-dark btn-inline"
                          href="/services"
                        >
                          Read more<i className="fa fa-plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="mt-30 res-991-mt-15 text-center">
                    <a className="end_button" href="/services">
                      <span>+</span>Explore More Sevices
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <>
  {/*broken-section*/}
  <section className="ttm-row broken-section ttm-bgcolor-grey clearfix">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="ttm-bg ttm-col-bgcolor-yes ttm-right-span ttm-bgcolor-white spacing-3 z-index-1">
            <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
            <div className="layer-content">
              <div className="row">
                <div className="col-lg-6 col-md-9 mx-md-auto col-sm-12 mx-sm-auto">
                  <div className="d-flex align-items-center ttm-boxes-spacing-10px ml-auto mb_10">
                    <div className="ttm-box-col-wrapper">
                      {/* ttm_single_image-wrapper */}
                      <div className="ttm_single_image-wrapper">
                      <img
                          className="img-fluid"
                          src={`${process.env.PUBLIC_URL}/assets/images/single-img-02.jpg`}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="ttm-box-col-wrapper">
                      <div className="ttm-bgcolor-skincolor pt-45 pr-30 pb-40 pl-30 mb-10">
                        <h3 className="mb-0">
                          We Are <br /> Trusted By More Than 100 Clients
                        </h3>
                      </div>
                      {/* ttm_single_image-wrapper */}
                      <div className="ttm_single_image-wrapper">
                      <img
                          className="img-fluid"
                          src={`${process.env.PUBLIC_URL}/assets/images/single-img-03.jpg`}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-xs-12">
                  <div className="pt-30 pl-20 res-991-pl-0 res-991-pt-50">
                    {/* section title */}
                    <div className="section-title">
                      <div className="title-header">
                        <h5>ABOUT US</h5>
                        <h2 className="title">
                          Achieve Global &amp; Local Reach with Our Indian
                          Language Experts
                        </h2>
                      </div>
                    </div>
                    {/* section title end */}
                    <div
                      className="ttm-tabs ttm-tab-style-01 pt-15"
                      data-effect="fadeIn"
                    >
                      <ul className="tabs clearfix">
                        <li className="tab active">
                          <a href="#">Our Mission</a>
                        </li>
                        <li className="tab">
                          <a href="#">Our Vision</a>
                        </li>
                        <li className="tab">
                          <a href="#">Philosophy</a>
                        </li>
                      </ul>
                      <div className="content-tab">
                        {/* content-inner */}
                        <div className="content-inner active">
                          <p>
                            Our mission at <strong>Meta Mind Inc</strong> is to
                            break down language barriers and connect businesses
                            to Indian and global audiences through precise,
                            culturally adapted translation services. We aim to
                            empower organizations by facilitating clear,
                            accurate, and effective multilingual
                            communication—especially in major Indian languages
                            like Hindi, Bengali, Tamil, Telugu, and more.
                          </p>
                          <p>
                            We are committed to maintaining the highest
                            standards in quality, confidentiality, and customer
                            satisfaction, ensuring every project reflects our
                            clients’ messages with authenticity and local
                            impact.
                          </p>
                          <a
                            href="services.html"
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor ttm-icon-btn-right mt-15 mr-2"
                          >
                            GET SERVICES
                            <i className="fa fa-plus" />
                          </a>
                          <a
                            href="contact-us.html"
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark ttm-icon-btn-right mt-15"
                          >
                            CONTACT US
                            <i className="fa fa-plus" />
                          </a>
                        </div>
                        {/* content-inner end*/}
                        {/* content-inner */}
                        <div className="content-inner">
                          <p>
                            Our vision is to be a leading force in translation
                            and localization services across India and
                            beyond—enabling businesses to scale effortlessly in
                            diverse linguistic markets. From regional outreach
                            to international expansion, we support every
                            communication strategy.
                          </p>
                          <p>
                            We aspire to innovate continuously, expand our
                            Indian language expertise, and embrace emerging
                            technologies such as AI and machine learning to
                            ensure language is never a barrier to growth.
                          </p>
                          <a
                            href="services.html"
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor ttm-icon-btn-right mt-15 mr-2"
                          >
                            GET SERVICES
                            <i className="fa fa-plus" />
                          </a>
                          <a
                            href="contact-us"
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark ttm-icon-btn-right mt-15"
                          >
                            CONTACT US
                            <i className="fa fa-plus" />
                          </a>
                        </div>
                        {/* content-inner end*/}
                        {/* content-inner */}
                        <div className="content-inner">
                          <p>
                            At <strong>Meta Mind Inc</strong>, we believe
                            language is more than just a tool—it's a cultural
                            bridge. Our philosophy centers on delivering
                            translations that honor the regional essence and
                            linguistic nuances of Indian communities, helping
                            clients connect with local audiences meaningfully.
                          </p>
                          <p>
                            Through collaboration, innovation, and deep cultural
                            respect, we foster lasting partnerships and ensure
                            every word we translate builds trust and engagement.
                          </p>
                          <a
                            href="services.html"
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor ttm-icon-btn-right mt-15 mr-2"
                          >
                            GET SERVICES
                            <i className="fa fa-plus" />
                          </a>
                          <a
                            href="contact-us"
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark ttm-icon-btn-right mt-15"
                          >
                            CONTACT US
                            <i className="fa fa-plus" />
                          </a>
                        </div>
                        {/* content-inner end*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/*broken-section end*/}
</>
          {/* testimonial-section */}
          <section className="ttm-row testimonial-section ttm-bgcolor-darkgrey ttm-bgimage-yes bg-img1 ttm-bg clearfix">
            <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h5>TESTIMONIALS</h5>
                      <h2 className="title">What Our Clients Say?</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <Slider
                  className="slick_slider slick-dots-style2 text-center"
                  slidesToShow={3}
                  slidesToScroll={1}
                  arrows={false}
                  autoplay={true}
                  dots={true}
                  infinite={true}
                  responsive={[
                    {
                      breakpoint: 1199,
                      settings: {
                        slidesToShow: 3
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 2
                      }
                    },
                    {
                      breakpoint: 620,
                      settings: {
                        slidesToShow: 1
                      }
                    }
                  ]}
                >
                <div className="col-lg-4">
                  <div className="testimonials style1">
                    <div className="testimonial-avatar" />
                    <div className="testimonial-content">
                      <i className="ti-quote-left" />
                      <blockquote>
                        We’ve worked with Meta Mind Inc on multilingual website
                        content, and their translations are always precise and
                        culturally adapted. Excellent team!
                      </blockquote>
                      <div className="testimonial-caption">
                        <h5>Rohan Mehta</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="testimonials style1">
                    <div className="testimonial-avatar" />
                    <div className="testimonial-content">
                      <i className="ti-quote-left" />
                      <blockquote>
                        Meta Mind Inc delivered accurate and well-formatted
                        translation of our technical manuals. Their professionalism
                        and turnaround time are impressive.
                      </blockquote>
                      <div className="testimonial-caption">
                        <h5>Neha Sharma</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="testimonials style1">
                    <div className="testimonial-avatar" />
                    <div className="testimonial-content">
                      <i className="ti-quote-left" />
                      <blockquote>
                        Thanks to Meta Mind Inc, we successfully localized our
                        marketing campaigns in over 10 languages. Their team is
                        both knowledgeable and efficient.
                      </blockquote>
                      <div className="testimonial-caption">
                        <h5>Priya Deshpande</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="testimonials style1">
                    <div className="testimonial-avatar" />
                    <div className="testimonial-content">
                      <i className="ti-quote-left" />
                      <blockquote>
                        We had urgent needs for certified translations. Meta Mind
                        Inc provided fast delivery and exceptional accuracy. Highly
                        recommended for legal translations.
                      </blockquote>
                      <div className="testimonial-caption">
                        <h5>Arjun Patel</h5>
                      </div>
                    </div>
                  </div>
                </div>
                </Slider>
              </div>
            </div>
          </section>

          {/* Translation Expertise + Process */}
          <section className="ttm-row broken-section clearfix">
            <div className="container">
              <div className="row row-equal-height g-0">
                <div className="col-lg-6">
                  <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-white spacing-5 h-100">
                    <div className="section-title">
                      <div className="title-header">
                        <h5>Translation Expertise</h5>
                        <h2 className="title">
                          Indian Language Solutions for Diverse Industries
                        </h2>
                      </div>
                    </div>
                    <p>
                      Meta Mind Inc. specializes in professional translation
                      services across major Indian languages, including Hindi,
                      Bengali, Tamil, Telugu, Marathi, Gujarati, Kannada,
                      Malayalam, Punjabi, and more.
                    </p>
                    <p>
                      We serve multiple industries with tailored linguistic
                      support—from legal, medical, finance, and technical
                      documentation to e-commerce, education, and software
                      localization.
                    </p>
                    <div className="pt-25">
                      <div className="ttm-progress-bar" data-percent="85%">
                        <div className="progressbar-title">
                          All Indian Language Coverage
                        </div>
                        <div className="progress-bar-inner">
                          <div className="progress-bar progress-bar-color-bar_skincolor" />
                        </div>
                        <div className="progress-bar-percent" data-percentage="85">
                          85%
                        </div>
                      </div>
                      <div className="ttm-progress-bar clearfix" data-percent="90%">
                        <div className="progressbar-title">
                          Industry-Specific Solutions
                        </div>
                        <div className="progress-bar-inner">
                          <div className="progress-bar progress-bar-color-bar_skincolor" />
                        </div>
                        <div className="progress-bar-percent" data-percentage="90">
                          90%
                        </div>
                      </div>
                      <div className="ttm-progress-bar clearfix" data-percent="75%">
                        <div className="progressbar-title">
                          Certified Accuracy & Quality
                        </div>
                        <div className="progress-bar-inner">
                          <div className="progress-bar progress-bar-color-bar_skincolor" />
                        </div>
                        <div className="progress-bar-percent" data-percentage="75">
                          75%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 m-auto">
                  <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-grey ttm-right-span spacing-4">
                    <div className="ttm_single_image-wrapper">
                      <img
                        className="img-fluid"
                        src={`${process.env.PUBLIC_URL}/assets/images/single-img-04.jpg`}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

 {/*broken-section*/}
 <section className="ttm-row broken-section bg-layer clearfix pb-40">
    <div className="container">
      {/* row */}
      <div className="row g-0">
        <div className="col-lg-5 col-md-12">
          <div className="ttm-bg ttm-col-bgcolor-yes ttm-left-span ttm-bgcolor-darkgrey z-index-1 spacing-7">
            <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
            <div className="layer-content">
              {/* section title */}
              <div className="section-title">
                <div className="title-header">
                  <h2 className="title">Translation Process</h2>
                </div>
              </div>
              {/* section title end */}
              <p>Fast. Accurate. Global. Get your content translated today!</p>
            </div>
          </div>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="ttm-bg ttm-col-bgcolor-yes ttm-right-span ttm-bgcolor-skincolor spacing-8">
            <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
            <div className="layer-content">
              <div className="row ttm-vertical_sep">
                <div className="col-md-3 col-sm-3 col-6 ttm-box-col-wrapper">
                  {/* featured-icon-box */}
                  <div className="featured-icon-box icon-align-top-content mt-15 mb-15 text-center">
                    <div className="featured-icon-box-inner">
                      <div className="ttm-icon ttm-icon_element-color-white ttm-icon_element-onlytxt ttm-icon_element-size-lg mb-10">
                        <i className="flaticon flaticon-customer-service-1" />
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h5>Analyze</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* featured-icon-box end*/}
                </div>
                <div className="col-md-3 col-sm-3 col-6 ttm-box-col-wrapper">
                  {/* featured-icon-box */}
                  <div className="featured-icon-box icon-align-top-content mt-15 mb-15 text-center">
                    <div className="featured-icon-box-inner">
                      <div className="ttm-icon ttm-icon_element-color-white ttm-icon_element-onlytxt ttm-icon_element-size-lg mb-10">
                        <i className="flaticon flaticon-customer-service" />
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h5>Translate</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* featured-icon-box end*/}
                </div>
                <div className="col-md-3 col-sm-3 col-6 ttm-box-col-wrapper">
                  {/* featured-icon-box */}
                  <div className="featured-icon-box icon-align-top-content mt-15 mb-15 text-center">
                    <div className="featured-icon-box-inner">
                      <div className="ttm-icon ttm-icon_element-color-white ttm-icon_element-onlytxt ttm-icon_element-size-lg mb-10">
                        <i className="flaticon flaticon-call-center-1" />
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h5>Review</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* featured-icon-box end*/}
                </div>
                <div className="col-md-3 col-sm-3 col-6 ttm-box-col-wrapper">
                  {/* featured-icon-box */}
                  <div className="featured-icon-box icon-align-top-content mt-15 mb-15 text-center">
                    <div className="featured-icon-box-inner">
                      <div className="ttm-icon ttm-icon_element-color-white ttm-icon_element-onlytxt ttm-icon_element-size-lg mb-10">
                        <i className="flaticon flaticon-world" />
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h5>Deliver</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* featured-icon-box end*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* row end */}
    </div>
  </section>
  {/*services-section end*/}
  
  {/*cta-section*/}
  <section className="ttm-row cta-section ttm-bgcolor-grey clearfix ">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 col-md-8 col-sm-12 m-auto">
          <div className="section-title">
            <div className="title-header">
              <h5>ABOUT US</h5>
              <h2 className="title">Have Any Questions?</h2>
            </div>
          </div>
          {/* section title end */}
          <div className="col-bg-img-three ttm-col-bgimage-yes ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-white h-auto mt-30">
            <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
              <div className="ttm-col-wrapper-bg-layer-inner" />
            </div>
            <div className="layer-content h-auto">
              <div className="cta_info_box box-shadow">
                <div className="ver_head ttm-bgcolor-skincolor">
                  <h3>Contact us!</h3>
                </div>
                <div className="right-content">
                  {/* featured-icon-box */}
                  <div className="featured-icon-box icon-align-before-content style4 d-inline-block ml_30">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-round">
                        <i className="flaticon-customer-service" />
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>For Any Inquiries Call Now!</p>
                      </div>
                      <div className="featured-title">
                        <h5>9876552511</h5>
                      </div>
                    </div>
                  </div>
                  {/* featured-icon-box end*/}
                  <div className="ttm-horizontal_sep pt-20 mt-20 w-100 m-auto" />
                  <h4 className="mb-0">
                    <a href="mailto:info@metamindinc.com">
                      info@metamindinc.com
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Right Column - FAQ */}
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FaqSection />
        </div>
      </div>
      {/* row end */}
    </div>
  </section>
  {/*cta-section end*/}

        </div>
        {/* ===== site-main end ===== */}
    </div>
  );
};

export default Home;